import React from 'react';
import { render, waitFor } from '@testing-library/react';
import DashboardLayout from './dashboard_layout';

jest.mock('../global/axios', () => ({
    get: jest.fn(),
}));

import axios from '../global/axios';

describe('DashboardLayout', () => {
    beforeEach(() => {
        jest.clearAllMocks();
    });

    it('shows loading indicator initially', () => {
        axios.get.mockReturnValue(new Promise(() => {}));
        const { container } = render(<DashboardLayout />);
        expect(container.querySelector('img') || container.textContent).toBeTruthy();
    });

    it('renders welcome message after loading', async () => {
        axios.get.mockResolvedValue({
            data: {
                user: { first_name: 'Jason', organization_name: 'Test Church' },
                apps: []
            }
        });
        const { getByText } = render(<DashboardLayout />);
        await waitFor(() => expect(getByText('Welcome, Jason')).toBeTruthy());
        expect(getByText('Test Church')).toBeTruthy();
    });

    it('renders app sections', async () => {
        axios.get.mockResolvedValue({
            data: {
                user: { first_name: 'Jason', organization_name: 'Test Church' },
                apps: [
                    { name: 'Slides', short_name: 'slides', link: '/slides', items: [
                        { id: 1, name: 'Sunday Sermon', updated_at: '2026-04-14' }
                    ]},
                ]
            }
        });
        const { getByText } = render(<DashboardLayout />);
        await waitFor(() => expect(getByText('Slides')).toBeTruthy());
        expect(getByText('Sunday Sermon')).toBeTruthy();
    });

    it('shows empty state when no apps enabled', async () => {
        axios.get.mockResolvedValue({
            data: {
                user: { first_name: 'Jason', organization_name: 'Test Church' },
                apps: []
            }
        });
        const { getByText } = render(<DashboardLayout />);
        await waitFor(() => expect(getByText('No apps enabled yet.')).toBeTruthy());
    });

    it('shows error state on API failure', async () => {
        axios.get.mockRejectedValue(new Error('Network error'));
        const { getByText } = render(<DashboardLayout />);
        await waitFor(() => expect(getByText('Unable to load dashboard.')).toBeTruthy());
    });
});
